<template>
  <div class="page-container">
      <el-row class="tac">
          <el-col :span="4">
              <h5>시스템 설정</h5>
              <el-menu
              :default-active="activeIndex"
              class="el-menu-vertical-demo"
              active-text-color="#6256ff"
              router>
                  <el-menu-item index="/system/serverip">
                      <span>서버 아이피 설정</span>
                  </el-menu-item>
                  <el-menu-item index="/system/client">
                      <span>클라이언트 버전</span>
                  </el-menu-item>
                  <el-menu-item index="/system/polling">
                      <span>Polling 시간 설정</span>
                  </el-menu-item>
                  <el-menu-item index="/system/function">
                      <span>기능 설정</span>
                  </el-menu-item>
              </el-menu>
          </el-col>
          <el-col :span="20">
              <router-view></router-view>
          </el-col>
      </el-row>
  </div>
</template>

<script>
export default {
    data () {
    return {
      activeIndex: this.$route.path
    }
  }
}
</script>

<style>

</style>